import { useState, useEffect } from "react";
import { apiCall } from "../api";

const DEFAULT_PROMO = { free_mode: false, rating_price_usd: 2, report_price_usd: 5, loaded: false };

// Fetched once per page load and shared by every component that asks
let promoRequest = null;

const usePromo = () => {
  const [promo, setPromo] = useState(DEFAULT_PROMO);

  useEffect(() => {
    if (!promoRequest) {
      promoRequest = apiCall('/promo').catch(() => DEFAULT_PROMO);
    }
    let active = true;
    promoRequest.then(data => { if (active) setPromo({ ...DEFAULT_PROMO, ...data, loaded: true }); });
    return () => { active = false; };
  }, []);

  return promo;
};

export { usePromo };
